import { render } from "./htmlEditor_v2.vue?vue&type=template&id=f6636b64"
import script from "./htmlEditor_v2.vue?vue&type=script&lang=js"
export * from "./htmlEditor_v2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__